module.exports = __webpack_public_path__ + "static/media/safari.e0d581c1.svg";